function getDefaultState() {
    return {
        process: null,
        currentStep: 0,
        subscription: {
            key: null,
            selectedCourse: null,
            selectedDate: null,
            selectedUnit: null,
            selectedDayTime: null,
            testType: null,
            formData: {},
            nameLabel: null,
            emailLabel: null,
            name: null,
            email: null,
            testId: null,
            candidatePassword: null,
            invoiceUrl: null
        },
    }
}


export const subscriptionsState = {
    namespaced: true,
    state: () => ({}),
    mutations: {
        resetState(state) {
            Object.assign(state, getDefaultState());
        },
        setStep(state, step) {
            window.scrollTo(0,0);
            state.currentStep = step;
        },
        setNameLabel(state, label){
            state.subscription.nameLabel = label
        },
        setEmailLabel(state, label){
            state.subscription.emailLabel = label
        }
    }
};